import React, { useMemo } from "react";
import { Alert } from "react-bootstrap";
import { FiltersBar } from "./FiltersBar";
import { DataTable } from "./DataTable";
import { ReportToolbar } from "./ReportToolbar";
import { useCSReportRunner } from "./useCSReportRunner";
import {
  downloadSummaryByTeacherCSV,
  fetchSummaryByTeacher,
} from "./csReportsApi";
import {
  buildReportParams,
  explicitColumns,
  validateBaseFilters,
} from "./reportHelpers";

const TEACHER_ROLLUP_COLUMNS = [
  ["teacher_email", "teacher_email"],
  ["first_name", "first_name"],
  ["last_name", "last_name"],
  ["school_name", "school_name"],
  ["last_session_date", "Last Session Date"],
  ["session_count", "Session Count"],
  ["session_count_gt_5_mins", "Session Count > 5 mins"],
  ["active_students", "Active Students"],
  ["avg_students_per_session", "Avg Students per session"],
  ["total_student_duration", "Total Student Duration (max of teacher selection)"],
  ["total_session_duration", "Total Session Duration (max of teacher selection)"],
  ["avg_session_duration", "Avg Session Duration (max of teacher selection)"],
];

export const SummaryByTeacherTab = ({
  filters,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const runner = useCSReportRunner({
    fetchJson: fetchSummaryByTeacher,
    fetchCsv: downloadSummaryByTeacherCSV,
    errorTag: "summary-by-teacher",
  });

  const validation = useMemo(
    () => validateBaseFilters({ filters, startDate, endDate }),
    [filters, startDate, endDate]
  );

  const params = useMemo(() => {
    if (!validation.ok) return null;
    return {
      ...buildReportParams({ filters, startDate, endDate }),
      roll_up: "teacher",
    };
  }, [filters, startDate, endDate, validation.ok]);

  const columns = useMemo(
    () => explicitColumns(TEACHER_ROLLUP_COLUMNS, runner.rows),
    [runner.rows]
  );

  return (
    <div>
      <FiltersBar
        filters={filters}
        startDate={startDate}
        endDate={endDate}
        onStartDateChange={onStartDateChange}
        onEndDateChange={onEndDateChange}
      />

      <ReportToolbar
        validation={validation}
        loading={runner.loading}
        downloading={runner.downloading}
        onRun={() => runner.run(params)}
        onDownload={() => runner.download(params)}
      />

      {runner.error && <Alert variant="danger">{String(runner.error)}</Alert>}

      {runner.rows !== null && (
        <DataTable
          data={runner.rows}
          columns={columns}
          emptyMessage="No sessions in this date range for the selected filters."
        />
      )}
    </div>
  );
};
